{
  "version": "0.0.0",
  "id": "at.softline.lagerhaus.klagenfurt.softline",
  "name": "Softline"
}
